import { createFileRoute } from "@tanstack/react-router";

import { PlanGate } from "~/components/app/plan-gate";
import { ConnectionNewPage } from "~/pages/connection-new/connection-new.page";

export const Route = createFileRoute(
  "/_app/settings/_organization/connections/new/",
)({
  component: () => (
    <PlanGate reason="fivetran">
      <ConnectionNewPage />
    </PlanGate>
  ),
});
